<template>
  <dpa-id-collab-graphql-provider
    v-if="graphqlBase && token"
    :endpoint="graphqlBase"
    :token="token"
  >
    <div id="app" class="flex flex-col h-full">
      <header class="h-16 text-white print:hidden bg-blue-highlight">
        <div class="flex items-center justify-between h-16 ml-4 mr-4 lg:mr-6">
          <div class="flex items-center whitespace-no-wrap">
            <svg
              width="94"
              height="32"
              viewBox="0 0 94 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2"
            >
              <path
                d="M7.7306 20.439C5.50196 20.439 3.96972 18.7675 3.96972 16.6086C3.96972 14.4495 5.50196 12.7781 7.7306 12.7781C9.95924 12.7781 11.4915 14.4495 11.4915 16.6086C11.4915 18.7675 9.95924 20.439 7.7306 20.439ZM11.1432 11.5942C9.81996 9.64409 7.80015 9.43508 6.75565 9.43508C2.71621 9.43508 0 12.5691 0 16.6086C0 20.5783 2.78576 23.8516 6.89493 23.8516C7.86988 23.8516 9.68068 23.6426 11.0737 21.6926V23.4338H14.9041V1.28662H11.1432V11.5942Z"
                fill="white"
              />
              <path
                d="M27.7184 19.4639C27.2308 19.9514 26.3952 20.4388 25.1415 20.4388C23.9575 20.4388 23.1218 19.9514 22.6343 19.5334C21.8682 18.9068 21.3808 17.8621 21.3808 16.6084C21.3808 15.3549 21.7986 14.3797 22.6343 13.6833C23.3308 13.0565 24.0968 12.7779 25.1415 12.7779C26.0469 12.7779 27.022 13.1262 27.7184 13.7529C28.4845 14.4495 28.9024 15.6334 28.9024 16.6084C28.9024 17.5835 28.5541 18.6978 27.7184 19.4639ZM26.1166 9.43506C23.6094 9.43506 22.3557 10.7583 21.7289 11.594V9.8529H17.8984V31.9999H21.6593V21.6925C23.1916 23.7122 25.0719 23.8514 26.0469 23.8514C28.0667 23.8514 29.5988 23.0855 30.6434 22.1104C31.4793 21.3442 32.8025 19.6729 32.8025 16.6084C32.8025 13.9619 31.7578 12.2208 30.7827 11.2457C29.2506 9.71362 27.3006 9.43506 26.1166 9.43506Z"
                fill="white"
              />
              <path
                d="M41.9965 20.4388C39.7679 20.4388 38.2356 18.7675 38.2356 16.6084C38.2356 14.4495 39.7679 12.7779 41.9965 12.7779C44.2251 12.7779 45.7572 14.4495 45.7572 16.6084C45.7572 18.7675 44.2251 20.4388 41.9965 20.4388ZM45.4787 9.8529V11.594C44.1554 9.64389 42.1358 9.43506 41.0911 9.43506C37.0517 9.43506 34.3354 12.5689 34.3354 16.6084C34.3354 20.5781 37.0517 23.8514 41.2304 23.8514C42.2053 23.8514 44.0161 23.6426 45.4091 21.6925V23.4336H49.2395V9.8529H45.4787Z"
                fill="white"
              />
              <path
                d="M61.7094 20.364C63.7771 20.364 65.4534 18.6878 65.4534 16.62C65.4534 14.5522 63.7771 12.876 61.7094 12.876C59.6416 12.876 57.9653 14.5522 57.9653 16.62C57.9653 18.6878 59.6416 20.364 61.7094 20.364Z"
                fill="white"
              />
              <path
                d="M91.6162 11.7267V0H93.8798V22.9189H91.6162V21.0955C90.8617 22.0701 89.4469 23.2962 87.1519 23.2962C83.8508 23.2962 80.8013 20.9697 80.8013 16.3796C80.8013 11.8839 83.8194 9.5574 87.1519 9.5574C89.667 9.5574 91.0189 10.9407 91.6162 11.7267ZM87.4034 11.5695C85.1713 11.5695 83.1277 13.2043 83.1277 16.3796C83.1277 19.1777 84.6997 21.2841 87.4034 21.2841C90.17 21.2841 91.742 18.9891 91.742 16.4111C91.742 13.0471 89.4155 11.5695 87.4034 11.5695Z"
                fill="white"
              />
              <path
                d="M75.079 9.8718H77.3426V22.9189H75.079V9.8718ZM74.6074 4.9359C74.6074 4.05561 75.3305 3.33252 76.2108 3.33252C77.0911 3.33252 77.8142 4.05561 77.8142 4.9359C77.8142 5.81619 77.0911 6.53928 76.2108 6.53928C75.3305 6.53928 74.6074 5.81619 74.6074 4.9359Z"
                fill="white"
              />
            </svg>
            <span class="heading-medium"> Mappen </span>
          </div>
          <div class="flex items-center align-center">
            <dpa-id-app-switcher is-light class="mx-4" />
            <dpa-id-user
              :token="token"
              :profile-url="profileUrl"
              @logout-click="handleLogout"
              is-light
            />
          </div>
        </div>
      </header>

      <main class="flex-grow">
        <router-view />
      </main>
      <ui-snackbar />
      <div class="mx-12">
        <hr class="border border-gray-300 border-solid" />
        <footer
          class="my-3 text-xs text-gray-700 justify-between leading-normal font-medium"
        >
          <a
            class="mr-3 hover:underline"
            href="https://account.dpa-id.de/imprint"
            target="_blank"
            >Impressum</a
          >
        </footer>
      </div>
    </div>
  </dpa-id-collab-graphql-provider>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
// @ts-ignore
import DpaIdAppSwitcher from "@dpa-id-components/dpa-id-app-switcher";
// @ts-ignore
import DpaIdUser from "@dpa-connect/dpa-id-user";
// @ts-ignore
import { DpaIdCollabGraphqlProvider } from "@dpa-connect/dpa-id-collab";
import UiSnackbar from "./components/UiSnackbar.vue";

export default Vue.extend({
  components: {
    DpaIdCollabGraphqlProvider,
    DpaIdAppSwitcher,
    DpaIdUser,
    UiSnackbar
  },
  computed: {
    ...mapState("stageConfig", ["profileUrl", "graphqlBase"]),
    token() {
      const token = this.$store.state.auth.token || "";
      return token;
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      this.logout();
      // Use Auth0 logout with return URL
      this.$auth0.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    }
  }
});
</script>

<style>
@import "~@dpa-connect/dpa-id-collab/lib/dpa-id-collab.css";
@import "~@dpa-connect/dpa-id-user/lib/dpa-id-user.css";
@import "~@dpa-id-components/dpa-id-app-switcher/lib/dpa-id-app-switcher.css";
</style>
